/*
 * @Author: panweikang
 * @Date: 2024-09-03 19:06:24
 * @LastEditTime: 2025-05-05 14:42:21
 * @Description: 
 */
import * as ActionTypes from "../ActionTypes";
import * as WebService from "../WebService";
import HttpUtils from "../../../utils/HttpUtils";
import { message, Modal } from "antd";
import { CACHE_ACCESS_TOKEN, CACHE_SESSION_USER } from "../../../constants/Profile";
import { APP_REFRESH_USER_INFO } from "../../../constants/ActionTypes";


export function sendSmsVerifyCode(mobile) {
  return (dispatch) => {
    dispatch({ type: ActionTypes.CMS_CONTENT_LOADING, isLoading: true });

    const params = {
      "phoneNumbers": mobile,
      "signName": "瑞莱博",
      "code": "SMS_224895226",
    };
    HttpUtils.post(
      WebService.sendAliyunVerifyCode,
      params,
      (response) => {
        message.success("发送成功");
        dispatch({ type: ActionTypes.CMS_CONTENT_LOADING, isLoading: false });
      },
      (response) => {
        dispatch({ type: ActionTypes.CMS_CONTENT_LOADING, isLoading: false });
      }
    );
  };
}

export function loginAction(params, callBack) {
  return (dispatch) => {
    dispatch({ type: ActionTypes.CMS_CONTENT_LOADING, isLoading: true });
    HttpUtils.post(
      WebService.authToken,
      params,
      (response) => {
        console.log('response', response)
        localStorage.setItem(CACHE_ACCESS_TOKEN, response.data.accessToken);
        setTimeout(async () => {
          dispatch(getSessionUser());
          await dispatch(getAuthStatus())
          await dispatch(getVipStatus())
          dispatch({ type: ActionTypes.CMS_CONTENT_LOADING, isLoading: false });

          callBack && callBack()
        }, 500)
      },
      (response) => { }
    );
  };
}


export function getSessionUser(callBack) {
  return (dispatch) => {
    dispatch({ type: ActionTypes.CMS_CONTENT_LOADING, isLoading: true });
    HttpUtils.get(
      WebService.getSessionUser,
      (response) => {
        let user = response.data;
        localStorage.setItem(CACHE_SESSION_USER, JSON.stringify(user));

        dispatch({ type: ActionTypes.CMS_CONTENT_LOADING, isLoading: false });
        dispatch({ type: APP_REFRESH_USER_INFO, userInfo: user });
      },
      (response) => {
      }
    );
  };
}

export function getAuthStatus() {
  return async (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: ActionTypes.CMS_CONTENT_LOADING, isLoading: true });
      HttpUtils.post(
        WebService.getAuthStatusApi,
        null,
        (response) => {
          dispatch({
            type: ActionTypes.SET_AUTH_STATUS,
            authStatus: response.data,
          });

          dispatch({
            type: ActionTypes.CMS_CONTENT_LOADING, isLoading: false
          });
          resolve()
        },
        (response) => {
          reject(response)
        }
      );
    });

  };
}

export function getVipStatus() {
  return async (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: ActionTypes.CMS_CONTENT_LOADING, isLoading: true });
      HttpUtils.post(
        WebService.getVipStatusApi,
        null,
        (response) => {
          dispatch({
            type: ActionTypes.SET_VIP_STATUS,
            temporaryVipStatus: response.data,
          });

          dispatch({ type: ActionTypes.CMS_CONTENT_LOADING, isLoading: false });
          resolve()
        },
        (response) => {
          reject(response)
        }
      );
    });
  };
}


export function logoutAction() {
  return (dispatch) => {
    HttpUtils.delete(
      WebService.logoutApi,
      {},
      (response) => {
        dispatch({
          type: ActionTypes.SET_TOKEN,
          token: null,
        });
        dispatch({
          type: ActionTypes.SET_USER_INFO,
          userInfo: null,
        });
      },
      (response) => { }
    );
  };
}
